import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import type { FeatureFlagName } from '@/global-hooks/use-feature-flag-enabled';
import { useFeatureFlagGate } from '@/global-hooks/use-feature-flag-enabled';
import { GeneralLoadingFallback } from '@/shared/modules/general-loading-fallback';

import { PagePaths } from './page-paths';

export type RequireFeatureFlagProps = PropsWithChildren<{
  /** Feature flag that gates this route. */
  flag: FeatureFlagName;
  /** Where a closed flag sends the visitor. Defaults to the Funds page. */
  redirectTo?: string;
}>;

/**
 * Route-level feature-flag gate. Shows a spinner while `useFeatureFlagGate` is still worth
 * waiting on, then either renders the route or redirects.
 */
export const RequireFeatureFlag: FC<RequireFeatureFlagProps> = ({ flag, redirectTo, children }) => {
  const gate = useFeatureFlagGate(flag);

  if (gate === 'loading') return <GeneralLoadingFallback />;
  if (gate === 'off') return <Navigate to={redirectTo ?? PagePaths.allFunds} replace />;
  return children;
};
